export const LOCALES = {
  EN_US: 'en-us',
  SV_SE: 'sv-se',
}

export const InvoiceToolVersion = {
  V1: 1,
  V2: 2,
}

export const NEW_ARTICLES = {
  MILEAGE: "mileage",
  ALLOWANCE_IN: "allowance_in",
  ALLOWANCE_OUT: "allowance_out",
  TRAVEL:"travel",
  MATERIAL_VAT: "material_vat"
}

export const AMOUNT_PER_UNIT = {
  MILEAGE: 2.50,
  ALLOWANCE_IN_HALF_DAY: 150,
  ALLOWANCE_IN_FULL_DAY: 300,

}

export const ARTICLE_NUMBERS = {
  MILEAGE_TAX_FREE: "87",
  MILEAGE_WITH_TAX: "88",
  ALLOWANCE_IN_TAX_FREE_HALF_DAY: "83",
  ALLOWANCE_IN_WITH_TAX_HALF_DAY: "84",
  ALLOWANCE_IN_TAX_FREE_FULL_DAY: "81",
  ALLOWANCE_IN_WITH_TAX_FULL_DAY: "82",
  ALLOWANCE_OUT_TAX_FREE: "85",
  ALLOWANCE_OUT_WITH_TAX: "86",
  TRAVEL:"91",
  MATERIAL_VAT_TAX_FREE: "2",
  MATERIAL_VAT_WITH_TAX: "1",
  MATERIAL_VAT_WITH_TAX_WITHOUT_PDF: "3",
}

export const VAT_TYPES = {
  SE_VAT: 1,
  SE_REVERSED_VAT: 2,
  EU_REVERSED_VAT: 3,
  EU_VAT: 4,
  EXPORT: 5
}

export const INVOICE_STATUS= {
  UNPAID: 1,
  PAID: 2,
  PARTIAL: 3
}